export default "__VITE_ASSET__D843uSJy__"